
import { Dialog, DialogContent, IconButton, MenuItem, TextField } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import ComboBox from "components/ComboBox"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { tyreApiNm, tyreColNm, tyreStsNm } from "./constant"
import { bahtProps } from "utils/bahtProps"
import { DesktopDatePicker } from "@mui/x-date-pickers-pro"
import dayjs from "dayjs"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import AddButton from "components/buttons/AddButton"
import { DeleteRounded } from "resource/muiImport"

let nextId = 1

const AddTyreBulkDialog = ({ dialogOpen, setDialogOpen, onFinish, tyreSizeCombo }) => {

  const { ax, msData } = useContext(GlobalStateContext)
  const [commonData, setCommonData] = useState({
    TyrBrand: "",
    TyrModel: "",
    TyrSzId: null,
    PurchPr: 0,
    PurchDte: dayjs().format("YYYY-MM-DD"),
    SupId: null,
    TyrStsId: 1,
    Dscp: "",
  })
  const [rows, setRows] = useState([])
  const [newTyrCd, setNewTyrCd] = useState("")

  const commonProp = useCallback((name) => ({
    fullWidth: true,
    size: "small",
    label: tyreColNm[name],
    value: commonData[name] ?? "",
    onChange: (e) => setCommonData(o => ({ ...o, [name]: e.target.value })),
  }), [commonData])

  const handleAddRow = useCallback(() => {
    if (!newTyrCd.trim()) return
    setRows(o => [...o, { id: nextId++, TyrCd: newTyrCd.trim() }])
    setNewTyrCd("")
  }, [newTyrCd])

  const handleDeleteRow = useCallback((id) => {
    setRows(o => o.filter(r => r.id !== id))
  }, [])

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      handleAddRow()
    }
  }, [handleAddRow])

  const handleDialogOk = useCallback(async () => {
    if (rows.length === 0) return
    const postData = {
      ...commonData,
      TyrCds: rows.map(r => r.TyrCd),
    }
    const value = await ax.post(tyreApiNm.insertTyreBulk, postData)
    if (value.data) {
      onFinish()
      setDialogOpen(false)
    }
  }, [ax, commonData, rows, onFinish, setDialogOpen])

  const columns = useMemo(() => [
    {
      field: "No",
      headerName: "No.",
      width: 50,
      align: 'center',
      renderCell: (params) => rows.findIndex(r => r.id === params.id) + 1,
    },
    {
      field: "TyrCd",
      headerName: "รหัสยาง",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "actions",
      headerName: "",
      width: 50,
      align: 'center',
      renderCell: (params) => (
        <IconButton size="small" onClick={() => handleDeleteRow(params.id)}>
          <DeleteRounded color="error" fontSize="small" />
        </IconButton>
      )
    },
  ], [rows, handleDeleteRow])

  useEffect(() => {
    if (!dialogOpen) {
      setCommonData({
        TyrBrand: "",
        TyrModel: "",
        TyrSzId: null,
        PurchPr: 0,
        PurchDte: dayjs().format("YYYY-MM-DD"),
        SupId: null,
        TyrStsId: 1,
        Dscp: "",
      })
      setRows([])
      setNewTyrCd("")
    }
  }, [dialogOpen])

  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='sm'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="เพิ่มยางหลายรายการ"
      />
      <DialogContent>
        <BoxFC pt={2} sx={{ gap: 1 }}>
          <BoxFR sx={{ gap: 1 }}>
            <TextField {...commonProp('TyrBrand')} />
            <TextField {...commonProp('TyrModel')} />
          </BoxFR>
          <ComboBox
            options={tyreSizeCombo || []}
            label={tyreColNm.TyrSzId}
            selectedId={commonData.TyrSzId}
            setSelectedId={(id) => setCommonData(o => ({ ...o, TyrSzId: id }))}
          />
          <BoxFR sx={{ gap: 1 }}>
            <TextField {...commonProp('PurchPr')} type="number" {...bahtProps} />
            <DesktopDatePicker
              label={tyreColNm.PurchDte}
              inputFormat="DD/MM/YYYY"
              value={commonData.PurchDte}
              onChange={(v) => setCommonData(o => ({ ...o, PurchDte: v ? dayjs(v).format("YYYY-MM-DD") : null }))}
              renderInput={(params) => <TextField size="small" fullWidth {...params} />}
            />
          </BoxFR>
          <TextField {...commonProp('TyrStsId')} select>
            {Object.entries(tyreStsNm).map(([key, label]) => (
              <MenuItem key={key} value={+key}>{label}</MenuItem>
            ))}
          </TextField>
          <ComboBox
            options={msData.supplierCombo || []}
            label={tyreColNm.SupId}
            selectedId={commonData.SupId}
            setSelectedId={(id) => setCommonData(o => ({ ...o, SupId: id }))}
          />
          <TextField {...commonProp('Dscp')} multiline rows={2} />

          <BoxFR sx={{ gap: 1 }}>
            <TextField
              size="small"
              fullWidth
              label="รหัสยาง"
              value={newTyrCd}
              onChange={(e) => setNewTyrCd(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <AddButton onClick={handleAddRow}>เพิ่ม</AddButton>
          </BoxFR>
          <BoxFC sx={{ height: 300 }}>
            <DataGridCellExpand
              hideFooter
              rows={rows}
              columns={columns}
            />
          </BoxFC>
        </BoxFC>
      </DialogContent>
      <DialogFooter okText={`บันทึก (${rows.length})`}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(AddTyreBulkDialog)
